/**
 *
 * @param {*} chartType
 * @param {*} dashboardAccrdion
 * @param {*} updateAccrdion
 * @description chartType:String  | dashboardAccrdion:[{chart:"ordercart" ,value:boolen},...] | updateAccrdion
 * @example {  const { updateAccrdion, dashboardAccrdion } = useDashboardSettings();}
 * @example { chartAccrdionHandler("orderChart", dashboardAccrdion)}
 */

const chartAccrdionHandler = (chartType, dashboardAccrdion ,updateAccrdion) => {
  if (dashboardAccrdion) {
    const findChart = dashboardAccrdion?.find(
      (item) => item.chart === chartType
    );
    updateAccrdion({ ...findChart, value: !findChart.value });
  }
};
export { chartAccrdionHandler };
